import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ngxCsv } from 'ngx-csv';
import { company_details } from 'src/app/global/global-variables';
import { LogsDataService } from 'src/app/logs/plugins/logs-data.service';
import { DatePickerComponent } from 'src/app/plugins/date-picker/date-picker.component';
import { ConfigService } from 'src/app/services/config-service';
import { DocumentGeneratorService } from 'src/app/services/document-generator.service';
import { HttpClientWrapperService } from 'src/app/services/http-client-wrapper.service';
import { PdfGeneratorService } from 'src/app/services/pdf-generator.service';

@Component({
  selector: 'app-whitelist-list',
  templateUrl: './whitelist-list.component.html',
  styleUrls: ['./whitelist-list.component.scss']
})
export class WhitelistListComponent implements OnInit {
  reportList = [];
  from: any;
  to: any;
  currentDate = new Date();
  totalElementCount = 0;
  totalPageCount = 1;
  pageNumber = 1;
  pageSize = 10;
  pageSizeArray = [10,100,1000,10000,15000];
    whitelistForm : FormGroup;
  whitelistedResponse : any[] = [];
  idtype: any[] = [{ label: 'STB', value: 1 }, { label: 'SUB', value: 2 }, { label: 'Product', value: 3 }];
  statusList: any[] = [{ label: 'Processing', value: 1 }, { label: 'Success', value: 2 }, { label: 'Failed', value: 0 }];
  thread : any = 'Not Selected'
  completeDownloadEnable: boolean = false;
  downloadOption: any[] = ['CSV'];
  disableDownload: boolean = true;
  filePath: any = '';
  fromDate : any = '';
  toDate : any = '';
  totalCount;
  status : any = 'ALL';
  hideFromAndTo : boolean = false;
  command : any = 'Not Selected';
  loader : boolean = false;
  maxDate: string;
  @ViewChild('reportTable', { static: false }) reportTable: ElementRef;
  @ViewChild('threadInput') threadInput: ElementRef;
  @ViewChild('commandInput') commandInput: ElementRef;
  @ViewChild('dateInput') dateInput: ElementRef;
  @ViewChild('statusSelect') statusSelect: ElementRef;

  constructor(
     public http: HttpClientWrapperService,
    private config: ConfigService,
    private doc: DocumentGeneratorService,
    private pdf: PdfGeneratorService,
    private report: LogsDataService,
    private fb: FormBuilder,
    private router: Router

  ) { }

  ngOnInit(): void {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
    this.whitelist();
    this.fetchData();
    if (this.fromDate == '') {
      this.hideFromAndTo = true;
    }
  }

  comapanyDetails = {
    name: company_details.name,
    address: company_details.address
  }
  whitelist() {
    this.whitelistForm = this.fb.group({
      pageSize: [this.pageSize, Validators.required],
      pageNumber: [this.totalPageCount, Validators.required],
    });

    this.settingDisplayValue();
  }
  settingDisplayValue() : string{
    if(this.whitelistForm.contains('status') || this.whitelistForm.contains('command') || this.whitelistForm.contains('stb_id') || this.fromDate != ''){
      return 'No Records'
    }else{
      return 'Choose Date'
    }
  }
  

  fetchData() {
    const body = this.whitelistForm.value;
    const url = `${this.config.json.apiEndpoint}getSmsCmdDetails${this.config.json.apiEndpointSuffix}`;
    this.loader = true;
    this.http.post(url, body).subscribe({
      next: (data) => {
        this.loader = false;
        this.whitelistedResponse = data.list;
        if (data.list.length <= 0) {
          this.totalPageCount = 1;
          this.pageNumber = 1;
        } else {
          this.totalPageCount = data.metaData.totalPageCount;
          this.totalElementCount = data.metaData.totalElementCount;
        }
      },
      error: (error) => {
        alert(error.error.error)
        this.loader = false;
      },
      complete: () => {}
    });
}

// dateChange(event: { startDate: Date, endDate: Date }): void {
//   this.hideFromAndTo = false;
//   const { startDate, endDate } = event;
//   if (startDate !== null && endDate !== null) {
//     this.fromDate = moment(startDate).format('YYYY-MM-DD');
//     this.toDate = moment(endDate).format('YYYY-MM-DD');
    
//     // Add fromDate and toDate controls to the form if they don't exist
//     if (!this.whitelistForm.contains('fromDate')) {
//       this.whitelistForm.addControl('fromDate', new FormControl(this.fromDate, Validators.required));
//     } else {
//       this.whitelistForm.get('fromDate').setValue(this.fromDate);
//     }

//     if (!this.whitelistForm.contains('toDate')) {
//       this.whitelistForm.addControl('toDate', new FormControl(this.toDate, Validators.required));
//     } else {
//       this.whitelistForm.get('toDate').setValue(this.toDate);
//     }

//     // Fetch the data with the updated form values
//     this.fetchData();
//   }
// }
dateChange(data: any) {
  this.fromDate = data.target.value;
  if (data.target.value) {
    if (!this.whitelistForm.get('date')) {
      this.whitelistForm.addControl('date', this.fb.control('', Validators.required));
    }
    this.whitelistForm.get('date')?.setValue(data.target.value);
  } else {
    if (this.whitelistForm.get('date')) {
      this.whitelistForm.removeControl('date');
    }
  }
  this.fetchData();
}

  changePageNumber(action: string): void {
    if (action === 'back' && this.pageNumber > 1) {
      this.pageNumber -= 1;
    } else if (action === 'front' && this.pageNumber < this.totalPageCount) {
      this.pageNumber += 1;
    }
    this.whitelistForm.patchValue({ pageNumber: this.pageNumber });
    this.fetchData();
  }

  changePageSize(e: Event) {
    this.pageSize = +(e.target as HTMLSelectElement).value;
    this.whitelistForm.patchValue({ pageSize: this.pageSize });
    this.pageNumber = 1; // Reset to first page on page size change
    this.whitelistForm.patchValue({ pageNumber: this.pageNumber });
    this.fetchData();
  }
  formatDate(ele) {
    var d = new Date(ele),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }
  showCompleteDownloadPopup() {
    this.completeDownloadEnable = true;
  }
  closeDownloadPopup() {
    this.disableDownload = true;
    this.completeDownloadEnable = false;
  }

  selectDownloadOption(option: string) {
    this.disableDownload = false;
  }

  downloadFullCSV() {
    this.whitelistForm.addControl('download', new FormControl(true, Validators.required));
    const body = this.whitelistForm.value;
    const url = `${this.config.json.apiEndpoint}getSmsCmdDetails${this.config.json.apiEndpointSuffix}`;
    this.http.post(url, body).subscribe({
      next: (data) => {
        this.completeDownloadEnable = false;
        const filePath = data.filePath;
        if (filePath) {
          this.filePath = data.filePath;
          const url = `${this.config.json.downloadUrl}${this.filePath}`
          const link = document.createElement('a');
          link.setAttribute('target', '_blank');
          link.setAttribute('href', url);
          link.setAttribute('download', `Sms_Cmd_Details.csv`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }else {
          setTimeout(()=>{
            alert('NO DATA FOUND');
          },1000)
        }
      },
      error: (error) => {
        this.completeDownloadEnable = false;
        alert(error.error.error)
      },
      complete: () => { }
    });
  }


  selectCommand(data: any) {
    const commandValue = data.target.value;
    const selectedCommand = this.idtype.find(ele => ele.value == commandValue);
    if (selectedCommand) {
      this.command = selectedCommand.label;
    }
    if (commandValue && commandValue != 0) {
      if (!this.whitelistForm.contains('command')) {
        this.whitelistForm.addControl('command', new FormControl(Number(commandValue), Validators.required));
      } else {
        this.whitelistForm.patchValue({
          command: Number(commandValue)
        });
      }
    } else {
      if (this.whitelistForm.contains('command')) {
        this.whitelistForm.removeControl('command');
      }
      this.command = 'ALL';
    }
    this.whitelistForm.patchValue({pageNumber : 1});
    this.pageNumber = 1;
    this.settingDisplayValue();
    this.fetchData();
  }

  threadId(data: any) {
    if (!data.target.value) {
      this.whitelistForm.removeControl('threadId');
      this.thread = 'Not Selected';
    } else {
      if (!this.whitelistForm.get('threadId')) {
        this.whitelistForm.addControl('threadId', new FormControl());
      }
      this.whitelistForm.patchValue({ threadId: Number(data.target.value)});
    }
    this.settingDisplayValue();
    this.fetchData();
  }
  
  commandId(data: any) {
    if (!data.target.value) {
      this.whitelistForm.removeControl('command');
      this.thread = 'Not Selected';
    } else {
      if (!this.whitelistForm.get('command')) {
        this.whitelistForm.addControl('command', new FormControl());
      }
      this.whitelistForm.patchValue({ command: data.target.value});
    }
    this.settingDisplayValue();
    this.fetchData();
  }
  
  refresh() {
    this.dateInput.nativeElement.value = '';
    this.threadInput.nativeElement.value = '';
    this.commandInput.nativeElement.value = '';
    this.statusSelect.nativeElement.value = 'Select Status';
    this.whitelistForm.reset();
    this.whitelistForm.patchValue({
      pageNumber: 1,
      pageSize : 10
    });
    this.pageNumber = 1;
    this.pageSize = 10;
    this.whitelistForm.removeControl('status');
    this.whitelistForm.removeControl('threadId');
    this.whitelistForm.removeControl('command');
    this.whitelistForm.removeControl('fromDate');
    this.whitelistForm.removeControl('toDate');
    this.command = 'Not Selected';
    this.status = 'Not Selected';
    this.pageNumber = 1;
    this.fetchData();
  }
  

  addSms(){
    this.router.navigate(['/sms/add-sms'])
  }
  


  selectStatus(data: any) {
    this.status = data.target.value;
    if (data.target.value == 'ALL') {
      this.status = 'ALL'
      this.whitelistForm.removeControl('status');
      this.fetchData();
    } else {
      this.statusList.forEach(ele=>{
        if(ele.value == data.target.value){
          this.status = ele.label
        }
      })
      if (!this.whitelistForm.contains('status')) {
        this.whitelistForm.addControl('status', new FormControl(''));
      }
      this.whitelistForm.get('status').enable();
      this.whitelistForm.get('status').setValue(Number(data.target.value));
      this.whitelistForm.patchValue({pageNumber : 1});
      this.pageNumber = 1;
      this.settingDisplayValue();
      this.fetchData();
    }
  }


  downloadTableExcel(): void {
    this.doc.exportTableToExcel(
      this.reportTable,
      'bouquet_subscription_desubscription_logs'
    );
  }

  downloadTablePdf(): void {
    if (this.formatDate(this.fromDate).includes('NaN')) {
      this.pdf.generatePdfHtml(
        '#reportTable',
        'Sms_Cmd_Details',
        `Date: Not Selected Status: ${this.status == 'ALL' ? 'ALL' : this.status}  Command: ${this.command == 'Not Selected' ? 'Not Selected' : this.command}  Thread: ${this.thread == 'Not Selected' ? 'Not Selected' : this.thread}`
      );
      return;
    }
    this.pdf.generatePdfHtml(
      '#reportTable',
      'Sms_Cmd_Details',
      `From Date: ${this.fromDate} To Date: ${this.toDate}   Status: ${this.status == 'ALL' ? 'ALL' : this.status} Command: ${this.command == 'Not Selected' ? 'Not Selected' : this.command}  Thread: ${this.thread == 'Not Selected' ? 'Not Selected' : this.thread}`
    );
  }

  downloadTableCSV(): void {
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      // title: false,
      useBom: true,
      // noDownload: true,
      headers: [
        'Log Date',
        'Subcriber ID',
        'STB ID',
        'MAC ID',
        'Bouquet Id',
        'Bouquet name',
        'Subscription Status',
        'Start date',
        'End date',
      ],
    };
    let data = [];
    if (this.whitelistedResponse.length > 0) {
      this.whitelistedResponse.forEach(report => {
        let csvLine = {
          // slNo : i,
          log_date: report.log_date,
          subscriber_id: report.subscriber_id,
          stb_id: report.stb_id,
          mac_id: report.mac_id,
          bouquet_id: report.bouquet_id,
          bouquet_name: report.bouquet_name,
          subscription_status: report.subscription_status,
          start_date: report.start_date,
          end_date: report.end_date,
        };
        data.push(csvLine);
      });
    } else {
      // If no data is available, push a message indicating no records found
      data.push({ "No Data": "No records found" });
    }
    new ngxCsv(data, 'Sms_Cmd_Details', options);
  }
}

